var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.photo !== null)?_c('div',{staticClass:"plugin-stores-photo",style:(_vm.imageStyle)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }